module.exports = __webpack_public_path__ + "arrow-right-black-fca2be1c7915646cc23c.svg";